import {Component, OnInit} from '@angular/core';
import {Constant} from '../../../../global/util/Constant';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {DocumentService} from '../../../service/document.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../../service/auth/auth.service';
import {DownloadGroup} from '../../../model/DownloadGroup';
import {Enterprise} from '../../../model/Enterprise';
import {Partner} from '../../../model/Partner';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {Dialog} from '../../../../global/util/Dialog';
import {InformType} from '../../../../global/util/enum/InformType';
import {ApplicationService} from '../../../service/application.service';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {EnterpriseService} from '../../../service/enterprise.service';
import {EnterpriseDataService} from '../../../service/data/enterprise-data.service';

@Component({
  selector: 'app-download-group-document',
  templateUrl: './download-group-document.component.html',
  styleUrls: ['./download-group-document.component.css']
})
export class DownloadGroupDocumentComponent implements OnInit {

  public loading: boolean;
  public title = 'TITLE.DOCUMENT-EMPTYING';
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  // TODO Evaluar si quizá podría definirse una clase genérica en común para todos los módulos con la finalidad de
  // almacenar los datos de cabecera que son de búsqueda
  public downloadGroup = new DownloadGroup();
  public partners: Partner[] = [];
  public enterprises: Enterprise[] = [];
  public downloadGroups: DownloadGroup[] = [];
  private groupSize = 1000;

  constructor(private documentService: DocumentService,
              private modalService: NgbModal,
              public authenticationService: AuthService,
              private applicationService: ApplicationService,
              private enterpriseService: EnterpriseService,
              private enterpriseDataService: EnterpriseDataService,
              private router: Router,
              private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.loadDefaultData();
  }

  private loadDefaultData() {
    this.enterprises = LocalStorage.getDefaultEnterprise();
    this.downloadGroup.enterpriseId = this.enterprises[Constant.ZERO_INDEX].id;
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partners = LocalStorage.getPartners();
      this.downloadGroup.partnerId = this.partners[Constant.ZERO_INDEX].id;
      this.getAllEnterprisesBy();
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      const partnerId = LocalStorage.getPartnerId();
      this.getEnterprisesByPartner(partnerId);
    } else {
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.INITIAL-DATA-RELOAD'));
    }
    this.getGroupDocuments(this.downloadGroup.enterpriseId);
  }

  /**
   * Obtiene la lista de agrupaciones de documentos
   */
  public getGroupDocuments(enterpriseId: number) {
    const url = Constant.ROOT_API_V1.concat('/documents/grouped?',
      'enterprise=', String(enterpriseId),
      '&size=', String(this.groupSize));
    this.loading = true;
    this.documentService.get(url).subscribe((next: any) => {
      this.loading = false;
      this.downloadGroups = next;
    }, () => {
      this.loading = false;
      this.downloadGroups = [];
    });
  }

  public hasRole(name: string): boolean {
    return this.authenticationService.hasRole(name);
  }

  public reloadEnterprises() {
    this.getEnterpriseBy(this.downloadGroup.partnerId);
  }

  public reloadGroupDocuments() {
    this.getGroupDocuments(this.downloadGroup.enterpriseId);
  }

  public downloadFiles(downloadGroup: DownloadGroup) {
    this.getDocumentFile(this.downloadGroup.enterpriseId, downloadGroup);
  }

  public getDocumentFile(enterpriseId: number, downloadGroup: DownloadGroup) {
    const url = Constant.ROOT_API_V1
      .concat('/documents/grouped/stream?',
        'enterprise=', String(enterpriseId),
        '&beginIndex=', String(downloadGroup.beginIndex),
        '&endIndex=', String(downloadGroup.endIndex));
    this.getStreamFile(url, 'zip');
  }

  downloadMetadata(downloadGroup: DownloadGroup) {
    this.getDocumentMetadata(this.downloadGroup.enterpriseId, downloadGroup);
  }

  public getDocumentMetadata(enterpriseId: number, downloadGroup: DownloadGroup) {
    const url = Constant.ROOT_API_V1
      .concat('/documents/metadata/stream?',
        'enterprise=', String(enterpriseId),
        '&beginIndex=', String(downloadGroup.beginIndex),
        '&endIndex=', String(downloadGroup.endIndex));
    this.getStreamFile(url, 'xlsx');
  }

  public getStreamFile(url: string, fileExtension: string) {
    this.loading = true;
    this.documentService.download(url).subscribe(next => {
      this.loading = false;
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      const today = LocalStorage.getTodayString();
      control.download = 'IOFESign-' + today + '-files.' + fileExtension;
      control.click();
    }, error => {
      this.loading = false;
      const title = 'TITLE.DOWNLOAD-FILE';
      this.processError(title, error);
    });
  }

  private processError(title: string, error: any) {
    const status = error.status;
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
        this.invalidateSessionAndRedirect();
      } else {
        Dialog.show(InformType.Danger, title);
      }
    } else {
      Dialog.show(InformType.Danger, title, error.error.message);
    }
  }

  private invalidateSessionAndRedirect() {
    this.applicationService.setUserLoggedIn(false);
    this.router.navigate(['login']);
  }

  private getAllEnterprisesBy() {
    this.enterpriseService.getAllEnterprises().subscribe(enterprises => {
      this.enterpriseDataService.setEnterprises(enterprises);
      const enterpriseFilter = enterprises.filter(value => value.partnerId === this.downloadGroup.partnerId);
      this.enterprises = LocalStorage.addEnterprise(enterpriseFilter).sort();
      if (this.enterprises.length > 0) {
        this.downloadGroup.enterpriseId = this.enterprises[Constant.ZERO_INDEX].id;
      }
    });
  }


  private getEnterprisesByPartner(partnerId: number) {
    this.enterpriseService.getEnterprisesByPartner(partnerId).subscribe(enterprises => {
      this.enterpriseDataService.setEnterprises(enterprises);
      this.enterprises = enterprises.sort();
      if (this.enterprises.length > 0) {
        this.downloadGroup.enterpriseId = this.enterprises[Constant.ZERO_INDEX].id;
      }
    });
  }

  /**
   * Filtra la empresa al seleccionar el partner
   * @param id
   * @private
   */
  private getEnterpriseBy(id: number): void {
    const enters = this.enterpriseDataService.getEnterprises();
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      if (id === Constant.ALL_PARTNER_ID) {
        this.enterprises = LocalStorage.getDefaultEnterprise();
      }
      const enterprisesFilter = enters.filter(value => id === value.partnerId);
      this.enterprises = LocalStorage.addEnterprise(enterprisesFilter);
      this.downloadGroup.enterpriseId = this.enterprises[Constant.ZERO_INDEX].id;
      this.getGroupDocuments(this.downloadGroup.enterpriseId);
    }
  }
}
